const accordionFunc = () => {
  const allRows = document.querySelectorAll(".product__accordion summary");
  allRows.forEach((row) => {
    row.addEventListener("click", (e) => {
      accordionClick(e);
    });
  });
};

const accordionClick = (eventHappened) => {
  let clickedElement = eventHappened.currentTarget;
  const parent = clickedElement.parentNode;

  const accDescritption = parent.querySelector(".accordion__content");

  const openRows = document.querySelectorAll("details");

  openRows.forEach((openRow) => {
    if (openRow.getAttribute("id") != parent.getAttribute("id")) {
      openRow.removeAttribute("open");
    }
  });

  document.querySelector(".product__accordion").scrollIntoView();
};

document.addEventListener("DOMContentLoaded", accordionFunc);
